import { gql } from "@apollo/client";

const markCustomsShipmentAsArchivedMutation = gql`
  mutation ($customsShipmentId: ID!) {
    markCustomsShipmentAsArchived(customsShipmentId: $customsShipmentId) {
      errors {
        customsShipmentId
      }
      updatedCustomsShipment {
        id
        canonicalId
        createdAt
        shippedOn
        archivedOn
        controlNumber
        canViewerMarkAsShipped
        canViewerMarkAsArchived
        canViewerSetControlNumber
      }
      succeeded
    }
  }
`;

export default markCustomsShipmentAsArchivedMutation;
